<template>
  <order-services @saved="$router.push('/travel-service')" @cancel="$router.push('/travel-service')" ref="orderServices" />
</template>

<script>
import OrderServices from "../../components/TravelService/OrderServices";

export default {
  name: "TravelServiceNewView",
  components: { OrderServices },
  beforeRouteLeave(from, to, next) {
    this.$refs.orderServices.beforeRouteLeave(from, to, next);
  }
};
</script>

<style scoped></style>
